import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";

// Models
import { Task } from "src/app/shared/model/task";
import { TaskCategory } from "src/app/shared/model/taskCategory";
import { DataWithName } from "src/app/modules/shared/model/dataWithName";

// Actions
import { beginGetTasks, beginGetTaskStatuses, beginGetTaskCategories, beginGetTaskModules, beginGetAccountNames, beginGetLeadNames,
    beginGetOpportunityNames, beginGetCaseNames, beginGetReminderTypes
} from "./taskData.actions";

@Injectable()

export class TaskDataService {
    constructor(
        private store: Store<{
            taskCategories: TaskCategory[],
            taskModules: any[],
            accountNames: DataWithName[],
            leadNames: DataWithName[],
            opportunityNames: DataWithName[],
            caseNames: DataWithName[],
            reminderTypes: any[]
        }>) {
            this.store.dispatch(beginGetTasks());
            this.store.dispatch(beginGetTaskStatuses());
            //this.store.dispatch(beginGetTaskCategories());
            this.store.dispatch(beginGetTaskModules());
            // this.store.dispatch(beginGetAccountNames());
            // this.store.dispatch(beginGetLeadNames());
            // this.store.dispatch(beginGetOpportunityNames());
            //this.store.dispatch(beginGetCaseNames());
            this.store.dispatch(beginGetReminderTypes());
    }

    loadTaskCategories(): Observable<TaskCategory[]> {
        return this.store.pipe(select('taskCategories'));
    }

    loadTaskModules(): Observable<any[]> {
        return this.store.pipe(select('taskModules'));
    }

    loadAccountNames(): Observable<DataWithName[]> {
        return this.store.pipe(select('accountNames'));
    }

    loadLeadNames(): Observable<DataWithName[]> {
        return this.store.pipe(select('leadNames'));
    }

    loadOpportunityNames(): Observable<DataWithName[]> {
        return this.store.pipe(select('opportunityNames'));
    }

    loadCaseNames(): Observable<DataWithName[]> {
        return this.store.pipe(select('caseNames'));
    }

    loadReminderTypes(): Observable<any[]> {
        return this.store.pipe(select('reminderTypes'));
    }
}
